import React from 'react';

export function Input({
  id = undefined,
  onChange = e => {},
  onFocus = e => {},
  onBlur = e => {},
  ref = undefined,
  disabled = false,
  placeholder = '',
  className = '',
  style = {},
  value = '',
  showValidationError = false,
  validationErrorText = '',
  isFocused = false,
  type = 'text',
}) {
  return (
    <div style={{ width: '100%' }} className={`${className}`}>
      <input
        id={id}
        disabled={disabled}
        autoFocus={isFocused}
        onChange={onChange}
        onFocus={onFocus}
        onBlur={onBlur}
        className={
          showValidationError
            ? `form-control form__input-error`
            : `form-control`
        }
        style={style}
        placeholder={placeholder}
        value={value}
        type={type}
        ref={ref}
      />
      {showValidationError && (
        <div className="form__input-error-text">{validationErrorText}</div>
      )}
    </div>
  );
}
export default Input;
